import { Pipe, PipeTransform } from '@angular/core';

const roundNumber = (number) => {
    return Math.abs(Math.round(number * 10) / 10);
}

@Pipe({
    name: 'displayCurrency',
    standalone: true
})

export class DisplayCurrencyPipe implements PipeTransform {
    transform(value: number, digitCount?: number): string {
      if (value === null || value === undefined) return '-';
      if (Math.abs(value) >= 1000000000) {
        const billions = value / 1000000000;
        return value < 0 ?
        `-$${roundNumber(billions)} Billion` :
        `$${roundNumber(billions)} Billion`
        }
      if (Math.abs(value) >= 1000000) {
        const millions = value / 1000000;
        return value < 0 ?
        `-$${roundNumber(millions)} Million` :
        `$${roundNumber(millions)} Million`;
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: digitCount ?? 0,
        maximumFractionDigits: digitCount ?? 0
      }).format(value);
    }
}
